import { ref, computed } from 'vue'
import { useTheme } from 'vuetify'
import {
  getStoredPortalTheme,
  persistPortalTheme,
  setPortalThemeName,
} from '@/utils/portalTheme'

export function useLoginTheme() {
  const vuetifyTheme = useTheme()
  const activeTheme = ref(getStoredPortalTheme())

  const isDark = computed(() => activeTheme.value === 'dark')

  const pageClass = computed(() => ({
    'login-page': true,
    'login-page--light': !isDark.value,
    'login-page--dark': isDark.value,
  }))

  function applyTheme(name) {
    activeTheme.value = name
    setPortalThemeName(vuetifyTheme, name)
    persistPortalTheme(name)
  }

  function setLight() {
    applyTheme('light')
  }

  function setDark() {
    applyTheme('dark')
  }

  return {
    activeTheme,
    isDark,
    pageClass,
    setLight,
    setDark,
  }
}
